import {
  Alert,
  Button,
  Col,
  Drawer,
  Form,
  Icon,
  Input,
  message,
  Radio,
  Row,
  Upload,
} from "antd";
import { gql } from "apollo-boost";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-apollo-hooks";
import IImageInfo from "src/interface/IImageInfo";
import { client } from "src/store/store";
import { filterSpecialStyle } from "src/util/helper";

import ImageCropper from "../imageCropper";
import { APP_SETTING, ORDER_INFO_CLIENT } from "../query/query";
import {
  innerDrawerBodyStyle,
  WrapAcctionButton,
  WrapEditWindow,
} from "./editor.styled";

// Drawer 를 닫는 Mutation
const DRAWER_CLOSE_MUTAION = gql`
  mutation DrawerClose {
    drawerClose @client
  }
`;

// 사용자가 필드를 수정하면 cache 에 반영하는 mutation
const APPLY_FIELD_CHANGE = gql`
  mutation ApplyChange($itemId: ID!, $contents: String, $sno: String) {
    applyChange(itemId: $itemId, contents: $contents, sno: $sno) @client
  }
`;

const Editor = () => {
  let makeProductItems: any = {};

  const [items, setItems] = useState(makeProductItems);
  const [imageInfo, setImageInfo] = useState<IImageInfo>();
  const [imageDrawerVisible, setImageDrawerVisible] = useState(false);
  const { data: appSetting } = useQuery(APP_SETTING);
  const { ordno, currentEditProductId, currentSno } = appSetting.app;

  const { data } = useQuery(ORDER_INFO_CLIENT, {
    variables: { ordno },
  });

  // mutations
  const [drawerClose] = useMutation(DRAWER_CLOSE_MUTAION);
  const [changeApplyMutation] = useMutation(APPLY_FIELD_CHANGE);

  // const resetAllField = useMutation(RESET_ALL_FIELD_MUTATION);

  // 기존에 추가되었던 이미지 모두를 없앤다. 마지막 이미지만 남겨둔다.
  const newImageOnlyDisplay = (itemId) => {
    const element = document.getElementById(itemId);
    if (element) {
      const targetList = element.querySelectorAll(
        ".ant-upload-list-picture-card .ant-upload-list-item"
      );
      for (let i = 0; i < targetList.length; i++) {
        if (i + 1 === targetList.length) {
          break;
        } else {
          targetList[i].remove();
        }
      }
    }
  };

  const cancelNewImageUpload = (itemId) => {
    const element = document.getElementById(itemId);
    if (element) {
      const targetList = element.querySelectorAll(
        ".ant-upload-list-picture-card .ant-upload-list-item"
      );
      targetList[targetList.length - 1].remove();
    }
  };

  let targetProduct: any;
  let targetItems: any;

  if (currentEditProductId !== 0 && data.orderInfo !== undefined) {
    targetProduct = _.find(data.orderInfo.productInfo, {
      id: currentEditProductId,
      sno: currentSno,
    });

    // sort items
    if (targetProduct.items) {
      targetItems = _.orderBy(targetProduct.items, ["sort"], ["asc"]);

      for (const item of targetItems) {
        makeProductItems = {
          ...makeProductItems,
          [item.id]: {
            id: item.id,
            type: item.type,
            contents: item.contents,
          },
        };
      }
    }
  }

  useEffect(() => {
    setItems(makeProductItems);
  }, [currentEditProductId, currentSno]);

  if (currentEditProductId !== 0 && data.orderInfo !== undefined) {
    return (
      <WrapEditWindow>
        {currentEditProductId !== 0 && data && (
          <Drawer
            title="케이크 디자인변경"
            placement="right"
            closable={false}
            width="100%"
            visible={appSetting.app.drawerOpen}
          >
            <div>
              <Form layout="vertical">
                {targetItems.map((item) => {
                  if (item && item.editable && items && items[item.id]) {
                    return (
                      <Row gutter={16} key={item.id}>
                        <Col span={24}>
                          <Form.Item label={item.title}>
                            {item.type === "TEXT" || item.type === "SVGTEXT" ? (
                              <Input
                                value={items[item.id].contents}
                                onChange={(e) => {
                                  setItems({
                                    ...items,
                                    [item.id]: {
                                      ...items[item.id],
                                      contents: e.target.value,
                                    },
                                  });

                                  changeApplyMutation({
                                    variables: {
                                      itemId: item.id,
                                      sno: item.sno,
                                      contents: e.target.value,
                                    },
                                  });
                                }}
                              />
                            ) : item.type === "TEXTAREA" ? (
                              <Input.TextArea
                                rows={6}
                                value={items[item.id].contents}
                                onChange={(e) => {
                                  setItems({
                                    ...items,
                                    [item.id]: {
                                      ...items[item.id],
                                      contents: e.target.value,
                                    },
                                  });

                                  changeApplyMutation({
                                    variables: {
                                      itemId: item.id,
                                      sno: item.sno,
                                      contents: e.target.value,
                                    },
                                  });
                                }}
                              />
                            ) : item.type === "IMAGE" ? (
                              <div id={`${item.id}-${item.id}_upload`}>
                                <Alert
                                  type="info"
                                  message={
                                    <>
                                      <Icon type="arrow-down" />
                                      &nbsp; 반드시 밝은 사진을 사용해주셔야
                                      합니다. 어두운 사진은 식별이 되지
                                      않습니다!
                                    </>
                                  }
                                  style={{ marginBottom: "10px" }}
                                />
                                <Upload
                                  key={item.sno + "-" + item.id}
                                  listType="picture-card"
                                  beforeUpload={(file) => {
                                    // cleanUploadList(`${item.id}_upload`);
                                    setImageInfo({
                                      ...item.imageInfo,
                                      file,
                                      itemId: item.id,
                                      sno: item.sno,
                                    });

                                    setImageDrawerVisible(true);
                                    return false;
                                  }}
                                >
                                  <div>
                                    <Icon type="plus" />
                                    <div className="ant-upload-text">
                                      변경하기
                                    </div>
                                  </div>
                                </Upload>
                              </div>
                            ) : item.type === "TEXTAREA_WITH_LINEHEIGHT" ? (
                              <>
                                <Radio.Group
                                  defaultValue="small"
                                  size="small"
                                  onChange={(e) => {
                                    const addStyleFragment = gql`
                                      fragment addStyleFromItem on ProductItem {
                                        addStyle
                                      }
                                    `;

                                    const curAddStyle = client.readFragment({
                                      id: item.sno + "|" + item.id,
                                      fragment: addStyleFragment,
                                    });

                                    const filteredStyle = filterSpecialStyle(
                                      curAddStyle.addStyle,
                                      "line-height"
                                    );

                                    client.writeFragment({
                                      id: item.sno + "|" + item.id,
                                      fragment: addStyleFragment,
                                      data: {
                                        __typename: "ProductItem",
                                        addStyle:
                                          filteredStyle +
                                          "line-height:" +
                                          e.target.value +
                                          ";",
                                      },
                                    });

                                    message.info(
                                      `선택하신 사이즈로 본문 레이아웃이 변경됩니다.`
                                    );
                                  }}
                                  style={{ marginBottom: "5px" }}
                                >
                                  {item.fontStyle &&
                                    item.fontStyle.lineHeightArray &&
                                    item.fontStyle.lineHeightArray.map(
                                      (heightItem, idx) => {
                                        return (
                                          <Radio.Button
                                            key={idx}
                                            value={heightItem.value}
                                          >
                                            {heightItem.subject}
                                          </Radio.Button>
                                        );
                                      }
                                    )}
                                </Radio.Group>

                                <Input.TextArea
                                  rows={6}
                                  value={items[item.id].contents}
                                  onChange={(e) => {
                                    setItems({
                                      ...items,
                                      [item.id]: {
                                        ...items[item.id],
                                        contents: e.target.value,
                                      },
                                    });

                                    changeApplyMutation({
                                      variables: {
                                        itemId: item.id,
                                        sno: item.sno,
                                        contents: e.target.value,
                                      },
                                    });
                                  }}
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  } else {
                    return null;
                  }
                })}
              </Form>
              <Row gutter={16} key={"action"}>
                <Col span={24}>
                  <WrapAcctionButton>
                    <Button
                      type="primary"
                      onClick={() => {
                        drawerClose();
                      }}
                    >
                      디자인보기
                    </Button>
                  </WrapAcctionButton>
                </Col>
              </Row>
            </div>
            <Drawer
              title="change Image"
              placement="right"
              width="100%"
              closable={false}
              visible={imageDrawerVisible}
              bodyStyle={innerDrawerBodyStyle}
            >
              {imageInfo && imageInfo.file && (
                <ImageCropper
                  imageInfo={imageInfo}
                  submitCallback={(imgData) => {
                    changeApplyMutation({
                      variables: {
                        itemId: imageInfo.itemId,
                        sno: imageInfo.sno,
                        contents: imgData,
                      },
                    });

                    newImageOnlyDisplay(`${imageInfo.itemId}_upload`);
                    setImageDrawerVisible(false);
                  }}
                  closeCallback={() => {
                    cancelNewImageUpload(`${imageInfo.itemId}_upload`);
                    setImageDrawerVisible(false);
                  }}
                />
              )}
            </Drawer>
          </Drawer>
        )}
      </WrapEditWindow>
    );
  } else {
    return <></>;
  }
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/editor/index.tsx